import { COUNTRY_OPTIONS, COUNTRY_PROVINCES } from 'legacy/util/constants';

export const getCountryName = (countryCode) => {
  const country = COUNTRY_OPTIONS.find((c) => c.value === countryCode);
  return country ? country.text : null;
};

export const getProvinceStateName = (countryCode, provinceCode) => {
  const country = COUNTRY_PROVINCES[countryCode];
  const province = country?.find((p) => p.text === provinceCode);
  return province ? province.value : null;
};
